import PhoenixDocCard from 'components/base/PhoenixDocCard';
import DocPageHeader from 'components/docs/DocPageHeader';
import AIModelsList from './AIModelsList';
import { Row, Col } from 'react-bootstrap';
import aimodels from 'assets/img/spot-illustrations/iamodels.png';

const AIModelsManagement = () => {
  return (
    <div>
      <DocPageHeader
        title="AI Adapter Deployments"
        description="Manage AI adapter configurations for Speech-to-Text (STT), Language Models (LLM), Text-to-Speech (TTS), and Analysis/Summary services."
      />

      <PhoenixDocCard className="mb-4">
        <PhoenixDocCard.Header noPreview className="py-4">
          <Row>
            <Col>
              <div>
                <h5 className="alert-heading mb-2">Important:</h5>
                <ul className="mb-0 fs-9">
                  <li>
                    <strong>Reusable Configurations:</strong> Each configuration
                    can be assigned to multiple agents, ensuring consistency and
                    reducing maintenance.
                  </li>
                  <li>
                    <strong>Security:</strong> API keys and sensitive data are
                    encrypted and stored securely.
                  </li>
                  <li>
                    <strong>Deletion Restrictions:</strong> Configurations in
                    use by agents cannot be deleted. Unassign them from agents
                    first.
                  </li>
                  <li>
                    <strong>Permissions:</strong> Only system administrators
                    with special credentials can create, edit, or delete
                    configurations.
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs="auto" className="order-xxl-2">
              <img src={aimodels} alt="" width={110} />
            </Col>
          </Row>
        </PhoenixDocCard.Header>
        <PhoenixDocCard.Body>
          <div className="px-4">
            <AIModelsList />
          </div>
        </PhoenixDocCard.Body>
      </PhoenixDocCard>
    </div>
  );
};

export default AIModelsManagement;
